import { render, staticRenderFns } from "./health_status.vue?vue&type=template&id=1bdf39d3"
import script from "./health_status.vue?vue&type=script&lang=js"
export * from "./health_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports